import { render, staticRenderFns } from "./CaseConfigSchema.vue?vue&type=template&id=59f794b4"
import script from "./CaseConfigSchema.vue?vue&type=script&lang=js"
export * from "./CaseConfigSchema.vue?vue&type=script&lang=js"
import style0 from "./CaseConfigSchema.vue?vue&type=style&index=0&id=59f794b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports